const images = {
  xuanquynh: require("./xuan-quynh.jpg"),
  minhnghiem: require("./minh-nghiem.jpg"),
  dinhminh: require("./dinh-minh.jpg"),
  hoangquynh: require("./hoangquynh.jpg"),
};

export default images;
